import {
  Colors,
  TextBold,
  TextReg,
  useDynamicStyles,
  type WithResponsive,
} from '@sunrise-ui/primitives';
import React from 'react';
import { StyleSheet, View } from 'react-native';

type Props = {
  name: string;
  title: string;
  initials?: string;
  align?: 'left' | 'right';
  topComment?: string;
  bottomComment?: string;
};

export function SponsorshipPersonCard({
  name,
  title,
  initials,
  align = 'left',
  topComment,
  bottomComment,
}: Props) {
  const styles = useDynamicStyles(createStyles, { align });

  const displayInitials =
    initials ||
    name
      .split(' ')
      .map((n) => n[0])
      .join('')
      .toUpperCase()
      .slice(0, 2);

  return (
    <View style={styles.wrapper}>
      {topComment && (
        <TextReg style={styles.comment} numberOfLines={3}>
          {topComment}
        </TextReg>
      )}
      <View style={styles.container}>
        {align === 'left' && (
          <View style={styles.avatar}>
            <TextBold style={styles.avatarText}>{displayInitials}</TextBold>
          </View>
        )}
        <View style={styles.textContainer}>
          <TextBold style={styles.name} numberOfLines={1}>
            {name}
          </TextBold>
          <TextReg style={styles.title} numberOfLines={1}>
            {title}
          </TextReg>
        </View>
        {align === 'right' && (
          <View style={styles.avatar}>
            <TextBold style={styles.avatarText}>{displayInitials}</TextBold>
          </View>
        )}
      </View>
      {bottomComment && (
        <TextReg style={styles.comment} numberOfLines={2}>
          {bottomComment}
        </TextReg>
      )}
    </View>
  );
}

const createStyles = ({ isMobile, align }: WithResponsive<Props>) =>
  StyleSheet.create({
    wrapper: {
      flex: 1,
      gap: isMobile ? 8 : 12,
    },
    container: {
      flexDirection: align === 'right' ? 'row-reverse' : 'row',
      alignItems: 'center',
      gap: isMobile ? 8 : 12,
      flex: 1,
    },
    avatar: {
      width: isMobile ? 40 : 48,
      height: isMobile ? 40 : 48,
      borderRadius: isMobile ? 20 : 24,
      backgroundColor: Colors.purple1opacity50,
      justifyContent: 'center',
      alignItems: 'center',
    },
    avatarText: {
      fontSize: isMobile ? 14 : 16,
      color: Colors.text,
    },
    textContainer: {
      flex: 1,
      alignItems: 'flex-start',
    },
    name: {
      fontSize: isMobile ? 14 : 16,
      color: Colors.text,
    },
    title: {
      fontSize: isMobile ? 11 : 13,
      color: Colors.opacity50,
    },
    comment: {
      fontSize: isMobile ? 12 : 14,
      color: Colors.opacity50,
      lineHeight: isMobile ? 18 : 20,
    },
  });
